import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allCustomersGPUOne: [],
  customerGPUOne: {},
  unassignedGPUOne: {
    machines: [],
    total: 0,
    currentPage: 1,
    perPage: 10,
    sortBy: '-last_updated',
  },
  assignedGPUOne: {
    machines: [],
    total: 0,
    currentPage: 1,
    perPage: 10,
    sortBy: '-last_updated',
  },
  organizationGPUOnePrefix: [],
  gpuOneMaasLogs: {},
  isLoading: false,
  error: null,
  gpuOneMachineDetails: {},
};

const gpuOneSlice = createSlice({
  name: 'gpuOne',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAllCustomersGPUOne: (state, action) => {
      state.allCustomersGPUOne = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerGPUOne: (state, action) => {
      state.customerGPUOne = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUnassignedGPUOne: (state, action) => {
      state.unassignedGPUOne = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setGPUOneMaasLogs: (state, action) => {
      const { systemSerial, data } = action.payload;
      state.gpuOneMaasLogs = {
        ...state.gpuOneMaasLogs,
        [systemSerial]: data,
      };
      state.isLoading = false;
      state.error = null;
    },
    setOrganizationGPUOnePrefix: (state, action) => {
      state.organizationGPUOnePrefix = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetGPUOne: () => {
      return initialState;
    },
    setMachineDetails: (state, action) => {
      state.gpuOneMachineDetails = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAllAssignedGPUOne: (state, action) => {
      state.assignedGPUOne = action.payload;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllCustomersGPUOne,
  setCustomerGPUOne,
  setUnassignedGPUOne,
  setGPUOneMaasLogs,
  setOrganizationGPUOnePrefix,
  setResetGPUOne,
  setMachineDetails,
  setAllAssignedGPUOne,
} = gpuOneSlice.actions;

export default gpuOneSlice.reducer;
